/*
 * same as Array.prototype.filter but for objects and also curried
 *
 * objectFilter(isString)({ a: 1, b: 'foo', c: null }) -> { b: 'foo' }
 *
 * in this example 'isString' is assumbed to be a function which checks whether
 * or not a value is a String
 */

module.exports = function objectFilter (filter) {
  return function (object) {
    const copy = { ...object }

    Object.keys(copy).forEach(
      key => {
        if (!filter(copy[key], key)) {
          delete copy[key]
        }
      }
    )

    return copy
  }
}
